import Button from '@pelckmans/elementis/components/button';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../../shared-components/EmptyState';

const BASE = 'PAGES.ASSIGNMENTS.TEACHER.SECTION.TABLE.EMPTY_STATE';

type Props = {
  id: string;
  archived?: boolean;
  filtered?: boolean;
  onClearFilters?: () => void;
};

function NoAssignmentsState({ archived, id, filtered, onClearFilters }: Props) {
  const { t } = useTranslation();

  const titleKey = archived ? `${BASE}.ARCHIVED.TITLE` : `${BASE}.TITLE`;
  const bodyKey = [BASE, archived && 'ARCHIVED', filtered && 'FILTERED', 'BODY'].filter(Boolean).join('.');

  return (
    <EmptyState
      id={id}
      variant="table"
      headerTitle={t(titleKey)}
      bodyText={t(bodyKey)}
      cta={
        filtered && (
          <Button prominence="secondary" size="md" as="button" onClick={onClearFilters}>
            {t(`${BASE}.FILTERED.CTA`)}
          </Button>
        )
      }
    />
  );
}

export default NoAssignmentsState;
